import * as types from './types';
import  update from  'immutability-helper';
import { scheduleViewTabs } from './utils';

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

const initialState = {
  activeTab: scheduleViewTabs.list,
  sortBy: { key: 'triggerAt', order: SortOrder.DESC }
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_TAB] = (state, action) => {
  return update(state, {
    activeTab: {
      $set: action.tab,
    }
  });
}

switchMap[types.SET_SORT_BY] = (state, action) => {
  return update(state, {
    sortBy: {
      $set: action.sortBy,
    }
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
